module.exports = __webpack_public_path__ + "img/swift-boosterjet-rojo-vanadio.8cfdb91c.png";